import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Row, Col, Modal, Button } from "react-bootstrap";
import { CATEGORIES, CREATENEW, CANCEL, ENABLE, DISABLE } from "../../../../shared/constants/Constants";
import ListView from "../../../../shared/components/listview/ListView"
import Breadcrumbs from "../../../../shared/components/Breadcrumbs"
import { loadCategoryTicketDataRequest, loadCategoryGetDataRequest, loadCategoryDeleteDataRequest } from "../redux/Actions";
import CategoryKB from "../../articleList/components/CategoryKB";
import DefaultButton from "../../../../shared/components/DefaultButton";
import Modalpopup from "../../../../shared/components/Modalpopup";
import Permissions from "../../../../shared/components/Permissions";
import dropdownFilterFunction from "../../../../shared/components/listview/dropdownFilterFunction";
import { setNextPrevIds } from "../../../next_prev_redux/Actions";
import { loadCompanyDataRequest } from "../../../company/redux/Actions";


const Categories = () => {

  let dispatch = useDispatch();
  let navigate = useNavigate();
  const { categorylist } = useSelector((store) => store.categories);
  let [clickEditFunc, setClickEditFunc] = useState(null);
  let [selectedRow, setSelectedRow] = useState({});
  let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
  let [clickStatusFunc, setClickStatusFunc] = useState(null);
  let [showStatusModal, setShowStatusModal] = useState(false);
  let [showQuestionsModal, setShowQuestionsModal] = useState(false);
  let [selectedQuestions, setSelectedQuestions] = useState([]);
  const [showArticleModal, setShowArticleModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [reload, setReload] = useState(false);
  let emp_no = JSON.parse(localStorage.getItem("emp_no"));
  let module_name = "Categories";
  let permission = Permissions(emp_no, module_name);
  let {companies } = useSelector((state) => state.company);
  

  useEffect(() => {
    if (categorylist?.data?.length) {
        const ids = categorylist.data.map(item => item.id);
        dispatch(setNextPrevIds(ids, CATEGORIES));
    }
  }, [categorylist]);

  useEffect(() => {
    dispatch(loadCategoryTicketDataRequest());
    dispatch(loadCompanyDataRequest());
  }, [dispatch, reload]);


  const transformedData = categorylist?.data?.map((item) => {

    // Routing rukes changes 
    const hasRouting = item.isrouting && item.routing;
    let routing_display = "Not Configured";

    if (hasRouting) {
      const groupName = item.routing.adminGroupName || "-";
      const assignedTo = item.routing.assignedToEmployee || "-";
      routing_display = `Group: ${groupName}\n${assignedTo} `;
      // routing_display = `Group: ${groupName} \nAssignee: ${assignedTo}`;
    }
    //  Truncate description to 100 words
    let truncatedDescription = item.description || "";
    const words = truncatedDescription.split(/\s+/);
    if (words.length > 10) {
      truncatedDescription = words.slice(0, 10).join(" ") + " ...";
    }
    // Admin & user portal changes
    return {
      ...item,
      description: truncatedDescription, // use truncated version
      adminportal: item.adminportal ? "YES" : "NO",
      ticketingportal: item.ticketingportal ? "YES" : "NO",
      // admin_portal_groups: Array.isArray(item.admin_portal_groups)
      //   ? item.admin_portal_groups.join(", ")
      //   : "",
      // ticketing_portal_groups: Array.isArray(item.ticketing_portal_groups)
      //   ? item.ticketing_portal_groups.join(", ")
      //   : "",
      admin_portal_groups: Array.isArray(item.admin_portal_groups)
        ? item.admin_portal_groups
          .filter((g) => g && g.trim() !== "") // remove empty/null entries
          .join(", ")
          .trim()
        : "",

      ticketing_portal_groups: Array.isArray(item.ticketing_portal_groups)
        ? item.ticketing_portal_groups
          .filter((g) => g && g.trim() !== "") // remove empty/null entries
          .join(", ")
          .trim()
        : "",
      // counting no of questions
      question_count: Array.isArray(item.questions)
        ? `${item.questions.length} Question${item.questions.length !== 1 ? "s" : ""}`
        : "0 Questions",
      // Keep questions for export
      questions_export: Array.isArray(item.questions) && item.questions.length > 0
        ? item.questions
          .map((q, index) => `${index + 1}. ${q.name || q.title || q.question}`)
          .join('\n')
        : 'No Questions',
      routing_display,
    };
  });

  // Extract unique template names for dropdown filter
  const templateOptions = useMemo(() => {
    if (!categorylist?.data) return [];

    const uniqueTemplates = [...new Set(
      categorylist.data
        .map(item => item.template_name)
        .filter(name => name && name.trim() !== "")
    )];

    return uniqueTemplates.map(name => ({ value: name, label: name }));
  }, [categorylist?.data]);

  const templateFilterFunc = dropdownFilterFunction(templateOptions);

  // Ticket type options for dropdown filter
  const ticketTypeOptions = [
    { value: "Ticket", label: "Ticket" },
    { value: "Workflow", label: "Workflow" }
  ];

  const ticketTypeFilterFunc = dropdownFilterFunction(ticketTypeOptions);

  // Extract unique categories for dropdown filter
  const categoryOptions = useMemo(() => {
    if (!categorylist?.data) return [];

    const uniqueCategories = [...new Set(
      categorylist.data
        .map(item => item.category)
        .filter(name => name && name.trim() !== "")
    )];

    return uniqueCategories.map(name => ({ value: name, label: name }));
  }, [categorylist?.data]);

  const categoryFilterFunc = dropdownFilterFunction(categoryOptions);

  // Extract unique subcategories for dropdown filter
  const subcategoryOptions = useMemo(() => {
    if (!categorylist?.data) return [];

    const uniqueSubcategories = [...new Set(
      categorylist.data
        .map(item => item.sub_category)
        .filter(name => name && name.trim() !== "")
    )];

    return uniqueSubcategories.map(name => ({ value: name, label: name }));
  }, [categorylist?.data]);

  const subcategoryFilterFunc = dropdownFilterFunction(subcategoryOptions);

  // Extract unique ticketing portal groups for dropdown filter
  const ticketingPortalGroupOptions = useMemo(() => {
    if (!categorylist?.data) return [];

    const allGroups = categorylist.data
      .flatMap(item =>
        Array.isArray(item.ticketing_portal_groups)
          ? item.ticketing_portal_groups
          : []
      )
      .filter(group => group && group.trim() !== "");

    const uniqueGroups = [...new Set(allGroups)];
    return uniqueGroups.map(name => ({ value: name, label: name }));
  }, [categorylist?.data]);

  const ticketingPortalGroupFilterFunc = dropdownFilterFunction(ticketingPortalGroupOptions);

  // Extract unique admin portal groups for dropdown filter
  const adminPortalGroupOptions = useMemo(() => {
    if (!categorylist?.data) return [];

    const allGroups = categorylist.data
      .flatMap(item =>
        Array.isArray(item.admin_portal_groups)
          ? item.admin_portal_groups
          : []
      )
      .filter(group => group && group.trim() !== "");

    const uniqueGroups = [...new Set(allGroups)];
    return uniqueGroups.map(name => ({ value: name, label: name }));
  }, [categorylist?.data]);

  const adminPortalGroupFilterFunc = dropdownFilterFunction(adminPortalGroupOptions);

  // Extract unique categories for dropdown filter
  const companyOptions = useMemo(() => {
  if (!companies) return [];
  return companies.map(c => ({ value: c.id, label: c.company_name }));
}, [companies]);

  const companyFilterFunc = dropdownFilterFunction(companyOptions);

  const handleOpenArticleModal = (category) => {
    setSelectedCategory(category);
    setShowArticleModal(true);
  };
  
   
  // const handleSaveArticle = (newArticle) => {
  //   console.log("Saving article:", newArticle);
  //   // TODO: dispatch or API call to save article here
  // };

  const handleArticleSuccess = () => {
    setShowArticleModal(false);
    setReload(prev => !prev);   //  force ListView to re-render with new data
  };

  const columnDefs = [
    {
      display_name: "id",
      field: "id",
      type: "number",
      hide: true,
      pinned: 'left'
    },
    {
      display_name: 'Actions',
      field: 'actions',
      pinned: 'left',
      width: 100,
    },
    {
      display_name: "Add Article",
      field: "article_id",
      type: "customButton",
      width: 130,

      //  IF article_id exists → Change button text + open as edit
      //  ELSE → show Add Article
      functionTo: (row) => handleOpenArticleModal(row),

      // OPTIONAL: if your ListView supports label override
      dynamicLabel: (row) => row.article_id ? "Edit Article" : "Add Article",

      pinned: 'left'
    },
    {
      display_name: "Category",
      field: "category",
      type: "dropdown",
      width: 150,
      pinned: 'left',
      dropdownOptions: categoryOptions.map(option => option.label),
      dropdownFunction: categoryFilterFunc,
    },
    {
      display_name: "Subcategory",
      field: "sub_category",
      type: "dropdown",
      width: 130,
      pinned: 'left',
      dropdownOptions: subcategoryOptions.map(option => option.label),
      dropdownFunction: subcategoryFilterFunc,
    },
    {
      display_name: "Description",
      field: "description",
      type: "text",
      render: (row) => (
        <span title={row.description}>{row.description}</span>
      ),
      width: 250,
    },

    {
      display_name: "Ticket Type",
      field: "ticket_type",
      type: "dropdown",
      width: 100,
      dropdownOptions: ["Ticket", "Workflow"],
      dropdownFunction: ticketTypeFilterFunc,
    },
    {
      display_name: "Company",
      field: "company_name",
      type: "dropdown",
      width: 180,
      dropdownOptions: companyOptions.map(option => option.label),
      dropdownFunction: companyFilterFunc,
    },

    {
      display_name: "Ticketing Portal",
      field: "ticketingportal",
      type: "customBadge",
      width: 130,

    },
    {
      display_name: "Ticketing Portal Groups",
      field: "ticketing_portal_groups",
      type: "dropdown",
      width: 180,
      dropdownOptions: ticketingPortalGroupOptions.map(option => option.label),
      dropdownFunction: ticketingPortalGroupFilterFunc,
    },
    {
      display_name: "Admin Portal",
      field: "adminportal",
      type: "customBadge",
      width: 130,

    },
    {
      display_name: "Admin Group",
      field: "admin_portal_groups",
      type: "dropdown",
      width: 180,
      dropdownOptions: adminPortalGroupOptions.map(option => option.label),
      dropdownFunction: adminPortalGroupFilterFunc,
    },
    {
      display_name: "Question Tempalte",
      field: "template_name",
      type: "dropdown",
      width: 150,
      dropdownOptions: templateOptions.map(option => option.label),
      dropdownFunction: templateFilterFunc,
    },
    {
      display_name: "Questions",
      field: "question_count",
      type: "customLink",
      functionTo: (row) => handleQuestionsClick(row),
      width: 130,
    },
    {
      display_name: "Questions Details",
      field: "questions_export",
      type: "text",
      width: 300,
      hide: true, // Hidden in the table view
    },
    {
      display_name: "Routing Rules",
      field: "routing_display",
      type: "text",
      width: 220,
      render: (row) => (
        row.routing_display === "Not Configured"
          ? "Not Configured"
          : (
            <>
              Group: {row.routing_display.split("\n")[0].replace("Group: ", "")}<br />
              {/* Assigned To: {row.routing_display.split("\n")[1].replace("Assigned To: ", "")} */}
            </>
          )
      ),
    },


  ]

  // To handle question popup
  const handleQuestionsClick = (row) => {
    if (Array.isArray(row.questions)) {
      setSelectedQuestions(row.questions);
    } else {
      setSelectedQuestions([]);
    }
    setShowQuestionsModal(true);
  };

  // Edit  
  useEffect(() => {
    setClickEditFunc(() => (row) => {
      setSelectedRow(row);
      dispatch(loadCategoryGetDataRequest(row.id));
      navigate(`/categoryform/${row.id}`);
      setReload(prev => !prev);
    });
  }, [dispatch, navigate]);
  // Delete
  useEffect(() => {
    setClickDeleteFunc(
      () => (row) => {
        setSelectedRow(row);
        // setShowStatusModal(true);

      })
  },

    [])
  //status
  useEffect(() => {
    setClickStatusFunc(
      () => (row) => {
        setSelectedRow(row);
        setShowStatusModal(true);

      })
  }, [])

  const handleStatus = async (row) => {
    await dispatch(loadCategoryDeleteDataRequest(row.id));
    setShowStatusModal(false);
    setReload(prev => !prev);
  };


  return <>
    <Row className="detailsPageHeader">
      <Col>
        <Breadcrumbs children={[{ href: "tickets/categories/", label: CATEGORIES }]} />
      </Col>

      <Col xs="auto" className="gx-0">
      {permission.create_permission ? (
        <DefaultButton
          buttonClass={"default-btn-color"}
          buttonTitle={CREATENEW}
          actionBlock={() => { navigate('/categoryform/add'); }}
        />
         ) : (<></>)}
      </Col>
    </Row>

    <ListView
      columnNames={columnDefs}
      rowData={transformedData}
      clickEdit={clickEditFunc}
      //clickDelete={clickDeleteFunc}
      clickStatus={clickStatusFunc}
    />
    <Modalpopup height="80vh" size="lg" show={showStatusModal} handleClose={() => setShowStatusModal(false)} actionTitle="Category Configuration">
      <p>
        {selectedRow?.status
          ? <>Do you want to Disable <strong>{selectedRow?.configname}</strong></>
          : <>Do you want to Enable <strong>{selectedRow?.configname}</strong></>
        }
      </p>

      <div className="col-md-12">
        <DefaultButton
          buttonClass="btn btn-secondary me-2"
          buttonTitle={CANCEL}
          actionBlock={() => setShowStatusModal(false)}
        />
        <DefaultButton
          buttonClass={selectedRow?.status ? "btn btn-danger" : "btn btn-success"}
          buttonTitle={selectedRow?.status ? DISABLE : ENABLE}
          actionBlock={() => handleStatus(selectedRow)}
        />
      </div>
    </Modalpopup>

    <Modal show={showQuestionsModal} onHide={() => setShowQuestionsModal(false)} size="lg" centered >
      <Modal.Header closeButton> <Modal.Title>Questions</Modal.Title></Modal.Header>
      <Modal.Body>
        {selectedQuestions.length > 0 ? (
          <div className="mt-3">
            {selectedQuestions.map((q, index) => (
              <div key={index} className="d-flex align-items-center border rounded p-2 mb-2 bg-light" >
                <div className="d-flex align-items-center gap-2">
                  <strong>{index + 1}. {q.name || q.title || q.question}</strong>
                  <span className="badge" style={{ backgroundColor: "rgba(0, 123, 255, 0.15)", color: "#0d6efd", borderRadius: "12px", fontWeight: "600", padding: "5px 10px", fontSize: "13px", }}>
                    {q.answerType === "text"
                      ? "Text"
                      : q.answerType === "options"
                        ? "Options"
                        : q.answerType}
                  </span>
                  {q.required && (<span className="badge" style={{ backgroundColor: "rgba(220, 53, 69, 0.15)", color: "#dc3545", borderRadius: "12px", fontWeight: "600", padding: "5px 10px", fontSize: "13px", }}>
                    Required
                  </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No questions found for this category.</p>
        )}
      </Modal.Body>
      <Modal.Footer> <Button variant="secondary" onClick={() => setShowQuestionsModal(false)}> Close </Button></Modal.Footer>
    </Modal>
    {/*  Add your CategoryKB modal here */}
    <CategoryKB
      show={showArticleModal}
      onHide={() => setShowArticleModal(false)}
      onSuccess={handleArticleSuccess}     //  new prop
      initialData={{ category: selectedCategory }}
    />




  </>
}

export default Categories;
